import { render } from "./UrlConfirm.vue?vue&type=template&id=722079d9&scoped=true&ts=true"
import script from "./UrlConfirm.vue?vue&type=script&lang=ts"
export * from "./UrlConfirm.vue?vue&type=script&lang=ts"

import "./UrlConfirm.vue?vue&type=style&index=0&id=722079d9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722079d9"]])

export default __exports__